import { render, staticRenderFns } from "./change-position.mpx?vue&type=template&id=1f4ab8b0&isComponent&outputPath=components%2Fchange-position6d3f4932%2Findex"
import script from "./change-position.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fchange-position6d3f4932%2Findex"
export * from "./change-position.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fchange-position6d3f4932%2Findex"
import style0 from "./change-position.mpx?vue&type=style&index=0&id=1f4ab8b0&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_6d3f4932%22%7D&isComponent&outputPath=components%2Fchange-position6d3f4932%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports